export default "__VITE_ASSET__a767c48f__"